import PropTypes from 'prop-types';
import React from 'react';
import Logo from './Logo';
import styles from './LoadingLogo.module.css';
export default function LoadingLogo(_a) {
    var companyIcon = _a.companyIcon, isPro = _a.isPro;
    if (isPro) {
        if (companyIcon) {
            return React.createElement("img", { className: styles.image, src: companyIcon });
        }
        return null;
    }
    return React.createElement(Logo, null);
}
LoadingLogo.propTypes = {
    companyIcon: PropTypes.string,
    isPro: PropTypes.bool.isRequired,
};
